import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * ScrollToTop component that scrolls to top on route changes.
 * Place this inside your Router component.
 *
 * Opt-out: navigate(to, { state: { preserveScroll: true } }) skips the reset —
 * used by in-page navigation that swaps content inline (e.g. the guest hub's
 * curation pager), where the caller manages its own scroll anchoring.
 */
export function ScrollToTop() {
  const { pathname, state } = useLocation()

  useEffect(() => {
    if ((state as any)?.preserveScroll) return
    // Scroll to top immediately
    window.scrollTo(0, 0)
  }, [pathname, state])

  return null
}
